import { dateRangeFromISO, getDateRange } from "@app/lib/date-range";
import CashPositionPage, {
  cashPositionQuery,
} from "@app/pages/cash-position/cash-position-page";
import type { cashPositionPage_Query } from "@app/queries/cashPositionPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/cash-position")({
  loader: () =>
    loadQuery<cashPositionPage_Query>(
      environment,
      cashPositionQuery,
      { from: dateRangeFromISO(getDateRange()) ?? undefined },
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("Cash position"),
  component: CashPositionRoute,
});

function CashPositionRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading cash position</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Computing cash position...</div>
        }
      >
        <CashPositionPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
